/**
 * @returns {null}
 */
function accountNo () {
  return null
}

module.exports = { accountNo }
